<template>
  <div class="container">
    <nav class="navbar text-center">
      <a class="navbar-brand" href="https://www.eventcreate.jp">
        <img src="./assets/logo.png" alt="イベントクリエイト">
      </a>
    </nav>

    <div id="app">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="scss">
  @font-face {
    font-family: "YuGothic M";
    src: local(Yu Gothic Medium);
  }

  body {
    padding: 20px 0;
    font-size: 14px;
    font-family: YuGothic, "YuGothic M", "メイリオ", sans-serif;
  }

  .navbar {
    margin-bottom: 20px;
  }

  #app {
    h2 {
      font-size: 1.5rem;
      margin-bottom: 1rem;
    }
    h3 {
      font-size: 1.25rem;
      margin-bottom: 1rem;
    }

    .form-group {
      label {
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?393f5ba9